export default {
	'.*TAYCAN_DEPOSIT_OPTION_PROGRAM.*': 'Taycan',
	'.*PORSCHE_FINANCING_2.*': 'Leasing vs Financing',
	'.*PORSCHE_FINANCING_1.*': 'Porsche Financial Services',
	'.*PORSCHE_PROTECTION_PLAN_1.*': 'Porsche Protection Plan',
	'.*PORSCHE_AUTO_INSURANCE_1.*': 'Porsche Auto Insurance',
	'.*PORSCHE_SERVICE_AND_PARTS_1.*': 'PD Service',
	'.*PORSCHE_APPROVED_CERTIFIED_PRE_OWNED_1.*': 'PD CPO',
	'.*THE_718_BOXSTER_AND_718_CAYMAN_1.*': 'PD 718',
	'.*THE_911_1.*': 'PD 911',
	'.*THE_CAYENNE_1.*': 'Cayenne',
	'.*THE_MACAN_1.*': 'PD Macan',
	'.*THE_PANAMERA_1.*': 'PD Panamera',
	'.*VIRTUAL_SHOW_ROOM_1.*': 'PD Virtual Showroom',
	'.*THE_TAYCAN_1.*': 'PD Taycan'
};
